import { Component, Input, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Parent } from 'src/app/model/parent';
import { Context } from 'src/app/model/context';

@Component({
  selector: 'app-parent',
  templateUrl: './parent.component.html',
  styleUrls: ['./parent.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class ParentComponent {  
  @Input() rank: number;
  @Input() parent: Parent;
  @Input() context: Context;

  categories: string[] = [
    "Auto-entrepreneur",
    "Chef d'entreprise (avec personnel salarié)",
    "Chef d'entreprise (sans personnel salarié)",
    "Salarié du secteur privé",
    "Salarié du secteur public / Fonctionnaire",
    "Professionnel libéral (avec personnel salarié)",
    "Professionnel libéral (sans personnel salarié)",
    "Sans activité",
    "Autre",
    "Non précisé"
  ];

  salaries = [
    "Aucun",
    "Un salarié",
    "De 2 à 10",
    "De 11 à 50",
    "De 51 à 200",
    "Plus de 200",
    "Non précisé"
  ];
}